import React from 'react';
import ViewContainer from '@loggi/ui/components/view-container';
import Col from '@loggi/ui/components/col';
import colors from '@loggi/ui/components/utils/colors';

function SearchResult({ empty, optionsCount, searchCount }) {
  const style = {
    borderTop: empty ? null : '#00baff 1px solid',
    backgroundColor: colors.hex[colors.type.LIGHTEST],
    color: colors.hex[colors.type.INFO],
    textAlign: 'center'
  };

  let msg = 'Nenhum resultado encontrado';
  if (!empty) {
    msg = (
      <span>
        {optionsCount} de <strong>{searchCount}</strong> resultados
      </span>
    );

    if (!searchCount) {
      msg = (
        <span>
          <strong>{optionsCount}</strong> resultados
        </span>
      );
    }
  }
  return (
    <ViewContainer className="text-sm" style={style}>
      <Col
        gutter={{
          top: 'half',
          bottom: 'half',
          left: 'normal',
          right: 'normal'
        }}
      >
        {msg}
      </Col>
    </ViewContainer>
  );
}

SearchResult.displayName = 'SearchResult';
export default SearchResult;
